import React, { useState } from "react";
import FormFieldProps from "features/shared/forms/dynamicForm/models/FormFieldProps";
import FormGroup from "features/shared/forms/components/FormGroup";
import { useTranslation } from "react-i18next";
import {
  getTranslatedText,
  getTranslatedTooltip,
} from "features/shared/forms/dynamicForm/helpers/dynamicFormHelper";
import FileInput from "features/shared/forms/components/FileInput";
import { useInjection } from "infrastructure/ioc/ioc.react";
import { IocTypes } from "infrastructure/ioc/ioc.types";
import FileValidator from "features/validation/validators/FileValidator";
import { getFullFileValidationMessage } from "features/shared/helpers/translationHelper";

const FileBoxMultipleField = ({
  descriptor,
  formHandler
}: FormFieldProps) => {
  // translations
  const t = useTranslation("shared\\dynamicForms").t;
  const tValidations = useTranslation("shared\\validations").t;

  // DI
  const fileValidator = useInjection<FileValidator>(IocTypes.FileValidator);

  // form hook props
  const {
    bindUncontrolledField,
    errors,
  } = { ...formHandler };

  const [fileError, setFileError] = useState<string | undefined>(undefined);

  const boundField = bindUncontrolledField(descriptor.name);

  // handlers
  const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    boundField.onChange(e);

    const files = e.target.files;

    if (files && files.length > 0) {
      const isValid = fileValidator.validateMultiple(files);
      setFileError(isValid ? undefined : getFullFileValidationMessage(tValidations, true));
    } else {
      setFileError(undefined);
    }
  };

  // render
  return (
    <div className={descriptor.className}>
      <FormGroup
        labelText={getTranslatedText(descriptor, "label", t)}
        validationError={fileError ?? (errors ? errors[descriptor.name] : undefined)}
        tooltip={getTranslatedTooltip(descriptor, t)}
      >
        <FileInput
          id={descriptor.name}
          multiple
          name={boundField.name}
          accept={fileValidator.getAcceptAttribute()}
          onChange={onChangeHandler}
          defaultText={getTranslatedText(descriptor, "placeholder", t)}
        />
      </FormGroup>
    </div>
  );
};

export default FileBoxMultipleField;
